import { Link } from 'react-router-dom';
import { Play, FileText, Paperclip } from 'lucide-react';
import styles from './BlockCard.module.css';
import MarkdownText from '../MarkdownText/MarkdownText';

export default function BlockCard({ block, channelSlug, channelHandle, index }) {
  const channelPath = channelHandle ? `/${channelHandle}/${channelSlug}` : `/channels/${channelSlug}`;

  const renderContent = () => {
    switch (block.type) {
      case 'image':
        return block.imageUrl ? (
          <img src={block.imageUrl} alt={block.title} className={styles.image} loading="lazy" />
        ) : (
          <div className={styles.placeholder} />
        );

      case 'link':
        return (
          <div className={styles.linkImageContent}>
            {block.imageUrl ? (
              <img src={block.imageUrl} alt={block.title} className={styles.image} loading="lazy" />
            ) : (
              <div className={styles.placeholder} />
            )}
            {block.sourceAuthor && (
              <span className={styles.linkDomain}>{block.sourceAuthor}</span>
            )}
          </div>
        );

      case 'text':
        return block.imageUrl ? (
          <img src={block.imageUrl} alt={block.title} className={styles.image} loading="lazy" />
        ) : (
          <div className={styles.textContent}>
            <MarkdownText value={block.content} disableLinks className={styles.textBody} />
          </div>
        );

      case 'media':
        return (
          <div className={styles.mediaContent}>
            {block.imageUrl ? (
              <img src={block.imageUrl} alt={block.title} className={styles.image} loading="lazy" />
            ) : (
              <div className={styles.placeholder} />
            )}
            <div className={styles.playIcon}>
              <Play size={24} fill="currentColor" />
            </div>
          </div>
        );

      case 'pdf':
        return block.imageUrl ? (
          <img src={block.imageUrl} alt={block.title} className={styles.image} loading="lazy" />
        ) : (
          <div className={styles.pdfContent}>
            <FileText size={40} className={styles.pdfIcon} />
            <span className={styles.pdfName}>{block.title}</span>
          </div>
        );

      case 'attachment':
        return block.imageUrl ? (
          <img src={block.imageUrl} alt={block.title} className={styles.image} loading="lazy" />
        ) : (
          <div className={styles.attachmentContent}>
            <Paperclip size={24} className={styles.attachmentIcon} />
            <span className={styles.fileName}>{block.title}</span>
          </div>
        );

      default:
        return <div className={styles.placeholder} />;
    }
  };

  return (
    <Link to={`${channelPath}/blocks/${block.id}`} className={styles.cardLink} style={index != null ? { animationDelay: `${Math.min(index, 12) * 0.04}s` } : undefined}>
      <div className={styles.card}>
        <div className={styles.content}>
          {renderContent()}
        </div>
        <div className={styles.caption}>
          <span className={styles.captionTitle}>
            {block.type === 'text'
              ? <MarkdownText value={block.title} inline disableLinks />
              : block.title}
          </span>
          {block.updated && <span className={styles.modified}>{block.updated}</span>}
        </div>
      </div>
    </Link>
  );
}
